import React, { Component } from "react";
import Create from "./view/Create.js";
import List from "./view/List.js";
import ViewModel from "./controllers/ViewModel.js";
import SubHeader from "../header/SubHeaderView.js";

export default class Departamentos extends Component {
  constructor(props) {
    super(props);
    this.viewModel = new ViewModel();
    this.viewModel.mirrorState = (s) => this.setState(s);
    this.viewModel.props = props;
  }

  componentDidMount() {
    this.viewModel.fetchData();
  }

  render() {
    return (
      <div className="page-content-wrapper">
        <SubHeader textoEsquerda="Painel" textoCentral="Departamentos" />
        <div className="page-content">
          <div className="container">
            {this.viewModel.state.showModal && <Create viewModel={this.viewModel} />}
            <List viewModel={this.viewModel} />
          </div>
        </div>
      </div>
    );
  }
}
